import { createAction, props } from '@ngrx/store';
import { UserActions } from './user.actions';

export enum SharedActions {
    SET_CURRENT_HIT_ID = '[Shared] set current hit id',
}

export const setCurrentHitId = createAction(SharedActions.SET_CURRENT_HIT_ID, props<{ hitId: string | undefined }>());
